import React from 'react'
import cn from 'classnames'

import { Flex, BoxHeadline, Label, Text } from 'shared/ui'

import { uncapitalize } from 'util/strings'
import { timeInHuman } from 'util/date'
import SanitizedHTML from 'shared/components/ui/SanitizedHTML'

import styles from './styles.css'

const ListItem = ({
  className,
  ticket: {
    titleLabel,
    body,
    bodyType = 'enduser',
    bodyAuthor,
    state,
    updated_at: time,
    message_count: messageCount,
  },
  onClick,
  sendingDelayed = false,
}) => {
  const humanizedTime = timeInHuman(time)
  const snippet = body ? body.replace(/^(@[\w]+)\s*/, '') : '' // remove leading twitter names
  const bodyHasAgentAuthor = bodyAuthor && bodyAuthor.type === 'Agent'

  return (
    <Flex
      className={cn(
        'grui overflow-hidden flex-col',
        styles.TicketListItem,
        styles[`TicketListItem-state-${state}`],
        className
      )}
      onClick={onClick}
    >
      {sendingDelayed && (
        <Flex>
          <BoxHeadline color="darkBerry">
            (Merge unavailable. {app.t('Ticket')} still sending...)
          </BoxHeadline>
        </Flex>
      )}
      <Flex className="grui overflow-hidden">
        <Flex className="grui overflow-hidden">
          <BoxHeadline truncate>
            {titleLabel || <em>No Subject</em>}
          </BoxHeadline>
          {messageCount > 1 && (
            <BoxHeadline className="grui ml-3" color="lightGray">
              ({messageCount})
            </BoxHeadline>
          )}
        </Flex>
        <Flex className="grui ml-10 justify-end flex-1-0-auto">
          <Label
            size="small"
            color="gray"
            fontWeight="normal"
            style={{ lineHeight: '24px' }}
          >
            {humanizedTime}
          </Label>
        </Flex>
      </Flex>

      <Flex
        className={cn(
          'TicketListItemMerge overflow-hidden',
          styles.TicketListItem_body,
          styles[`TicketListItem_${bodyType}`]
        )}
      >
        {bodyHasAgentAuthor && (
          <Text
            color="gray"
            size="small"
            fontWeight="bold"
            className="grui mr-3"
          >
            {`${uncapitalize(bodyAuthor.label)}: `}
          </Text>
        )}
        <Text color="gray" size="small" truncate>
          <SanitizedHTML html={snippet} />
        </Text>
      </Flex>
    </Flex>
  )
}

export default ListItem
